<template>
  <v-dialog v-model="finCENPrompt" persistent max-width="600px">
    <v-card>
      <v-card-title class="headline">
        <v-spacer/>FinCEN Report Required
      <v-spacer/>
      </v-card-title>
      <v-card-text class="text-center mt-2">
        <p>
          A FinCEN report will be required for this transaction.
        </p>
        <p class="mt-2">
          The total USD received from this member over the past 24 hours
          <strong>including this transaction</strong> exceeds the reporting threshold.
        </p>
        <p class="mt-1 font-weight-medium">
          Total USD received in the last 24 hours (including this transaction): <strong>{{ formattedAmount }}</strong>
        </p>

        <v-alert
            type="warning"
            dense
            icon="mdi-alert"
            outlined
            class="mt-4 text-left"
        >
          <p class="mb-2">
            If a member <strong>suggests or attempts to avoid reporting</strong>—for example, by splitting payments or mentioning amounts close to $10,000—
            <strong>you must still file Form 8300</strong>.
          </p>
          <ul class="pl-4">
            <li><strong>Check Box 1b</strong> to indicate the transaction is suspicious or structured to evade reporting.</li>
            <li><strong>Do not inform the member</strong> that Form 8300 is being filed. Federal law prohibits disclosing this.</li>
          </ul>
          <p class="mt-2">
            <strong>Structuring is illegal.</strong> You are required to report even if the total received is under $10,000, if you
            <strong>know or suspect</strong> the purpose is to evade reporting.
          </p>
        </v-alert>

        <v-btn class="mt-2"  color="primary" href="https://www.irs.gov/pub/irs-pdf/f8300.pdf" target="_blank">Begin Report in new tab</v-btn>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="finCENPrompt = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "FinCENDialog.vue",
  props: {
    reportAmount: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      finCENPrompt: false
    };
  },
  computed: {
    formattedAmount() {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      }).format(this.reportAmount || 0);
    },
  },
  methods: {
    openDialog() {
      this.finCENPrompt = true;
    },
    closeDialog() {
      this.finCENPrompt = false;
    }
  }
};
</script>

<style scoped>
</style>